import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import { FormCsvDataDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_GET_FORM_CSV_DATA = "GET_FORM_CSV_DATA";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const getFormCsvData = async (formId: string): Promise<FormCsvDataDto[]> => {
  const response = await formsApi.formsControllerGetFormCsvData(formId);

  return response.data;
};

export const useGetFormCsvData = (
  user: UserProfileDto | null,
): {
  getFormCsvDataAsync: UseMutateAsyncFunction<
    FormCsvDataDto[],
    Error,
    string,
    unknown
  >;
  getFormCsvDataEnabled: boolean;
  isSuccessGetFormCsvData: boolean;
  isPendingGetFormCsvData: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS, ACTION_GET_FORM_CSV_DATA],
    mutationFn: enabled ? getFormCsvData : undefined,
  });

  return {
    getFormCsvDataAsync: mutateAsync,
    getFormCsvDataEnabled: enabled,
    isSuccessGetFormCsvData: isSuccess,
    isPendingGetFormCsvData: isPending,
  };
};
